{
  "cancel": "Cancelar",
  "save": "Guardar",
  "manage": "Gestionar",
  "create": "Crear",
  "delete": " Eliminar ",
  "new": "Nuevo",
  "event_nav_title": "Navegación",
  "event_module_name_basic": "Básico",
  "event_module_name_sales": "Ventas",
  "perc": "%",
  "currency": "€",
  "event_manage": " Datos del evento ",
  "event_manage_products": "Productos",
  "event_manage_status": "Estado",
  "event_manage_minimum_age": "Nombre del evento",
  "event_manage_minimum_age_info": " Dejar vacío si no hay edad mínima ",
  "event_manage_name": "Nombre del evento",
  "event_product_title": "Gestionar productos de eventos",
  "event_product_saved": "Datos del producto actualizados!",
  "event_product_add": "Añadir producto",
  "product_name": "Nombre del producto",
  "product_modal_edit": "Editar producto",
  "product_modal_create": "Crear producto",
  "product_saved": "¡Producto actualizado!",
  "product_group": "Grupo",
  "product_status": "Estado",
  "nav_dashboard": "Panel de control",
  "nav_companies": "Gestionar empresas",
  "nav_events": "Mis eventos",
  "nav_company": "Mi empresa",
  "nav_discountcodes": "Códigos de descuento",
  "nav_orders": "Pedidos",
  "nav_reports": "Informes",
  "nav_administration": "Administración",
  "nav_extensions": "Erweiterungen",
  "app_logout": "Cerrar la sesión",
  "app_impersonating": " Estás suplantando a {name}. Haga clic en cerrar la sesión para volver a su propio rol de administrador ",
  "login_email": "dirección de correo electrónico",
  "login_password": "contraseña",
  "login_button": " iniciar sesión",
  "login_error": "Fallo en el inicio de sesión, por favor, inténtelo de nuevo",
  "events_title": "Gestionar eventos",
  "event_create": "Crear un evento nuevo",
  "event_new_modal_title": "Crear un evento",
  "event_name": "Nombre del evento",
  "event_create_hint": "Una vez creado el evento, puede configurar más opciones si lo desea.",
  "event_nav_manage": "Datos del evento",
  "event_nav_products": "Productos / Tickets",
  "event_nav_pos": "Puntos de venta",
  "event_nav_timeslots": "Franjas horarias",
  "event_manage_title": "Gestiona tu evento: {name}",
  "event_minimum_age": "Edad mínima",
  "event_status": "Estado",
  "event_starts_at": "El evento comienza el",
  "event_ends_at": "El evento finaliza el",
  "event_description": "Descripción del evento",
  "company_manage_title": "Gestionar la empresa {name}",
  "company_users": "Usuarios de la empresa",
  "company_details": "Datos de la empresa",
  "company_subdomain": "Subdominio",
  "company_contact": "Persona de contacto",
  "company_phone": "Número de teléfono",
  "company_address": "Dirección",
  "company_zip": "CÓDIGO POSTAL",
  "company_city": "Ciudad",
  "company_kvk": "Número Cámara de Comercio",
  "company_vat": "Número de IVA",
  "company_ticket_fee": "Tasa por ticket",
  "company_paynl_service_id": "ID de servicio de Pay.nl",
  "company_paynl_api_token": "Token API de Pay.nl",
  "company_paynl_token_code": "Código API de Pay.nl",
  "company_country": "País",
  "company_user_impersonate": "Suplantar",
  "user_create": "Añadir un nuevo usuario",
  "user_language": "Idioma",
  "user_create_modal_title": "Añadir nuevo usuario a {name}",
  "user_name": "Nombre",
  "user_email": "dirección de correo electrónico",
  "user_password": "Contraseña",
  "edit_user_modal_title": "Editar los datos del usuario",
  "user_password_hint": "Deje este campo vacío si no desea cambiar la contraseña",
  "content_top_welcome_message": "Bienvenido a {whitelabel_layout_name}",
  "event_pos_title": "Puntos de venta de eventos",
  "event_pos_create": "Añadir",
  "pos_modal_create": "Crear un nuevo punto de venta",
  "pos_name": "Nombre",
  "pos_language": "Idioma",
  "pos_url": "URL",
  "pos_modal_edit": "Editar TPV",
  "lang_en": "Inglés",
  "lang_nl": "Holandés",
  "lang_de": "Alemán",
  "lang_es": "Español",
  "event_timeslots": "Franjas horarias",
  "event_timeslot_title": "Gestiona tus franjas horarias: {name}",
  "timeslot_add": "Añadir una nueva franja horaria",
  "timeslot_modal_edit": "Editar franja horaria",
  "timeslot_modal_create": "Crear una nueva franja horaria",
  "timeslot_interval": "Intervalo",
  "timeslot_amount": "Cantidad",
  "interval_hourly": "Por hora",
  "timeslot_start": "Inicio de la franja horaria",
  "timeslot_end": "Fin de la franja horaria",
  "timeslot_starts_at": "Inicio",
  "timeslot_ends_at": "Fin",
  "timeslot_date": "Fecha",
  "timeslot_saved": "¡Franja horaria guardada!",
  "timeslot_created": "¡Franja horaria creada!",
  "pos_modal_edit_products": "Productos en stock para este punto de venta",
  "pos_products_hint": "Deje los stocks vacíos si no quiere ofrecer este producto en este punto de venta",
  "pos_payment_methods": "Métodos de pago",
  "payment_method": "Método de pago",
  "pos_open": "Comprar entradas",
  "pos_event_open": "Abrir",
  "pos_payment_method_fee_percentage": "Gastos de administración (porcentaje)",
  "pos_payment_method_fee_fixed": "Gastos de administración (importe)",
  "pos_updated": "¡Punto de venta actualizado!",
  "companies_title": "Gestionar empresas",
  "companies_create": "Añadir nueva empresa",
  "view_pos_minimum_age": "La edad mínima para este evento es de {minimum_age}",
  "view_pos_buy": "¡Comprar ahora!",
  "pos_product_sold_out": "Agotado",
  "cart_title": "Resumen del pedido",
  "cart_total": "Total",
  "cart_order": "Continuar",
  "cart_sub_total": "Subtotal",
  "cart_ticket_fee": "Costes administrativos",
  "cart_empty": "Su cesta está actualmente vacía, por favor añada algunos productos",
  "cart_button_hint": "Comprobamos la disponibilidad de su elección al hacer clic en Realizar pedido",
  "customer_company_name": "Nombre de la empresa",
  "customer_first_name": "Nombre",
  "customer_last_name": "Apellido",
  "customer_address": "Dirección completa",
  "customer_zip": "Código postal",
  "customer_city": "Ciudad",
  "customer_phone": "Número de teléfono",
  "customer_email": "Dirección de correo electrónico",
  "customer_dob": "Fecha de nacimiento",
  "customer_gender": "Sexo",
  "customer_gender_male": "Masculino",
  "customer_gender_female": "Femenino",
  "customer_personal_info": "Datos personales",
  "customer_contact_info": "Información de contacto",
  "order_payment_method": "Seleccione un método de pago",
  "cart_payment_fee": "Tasa de pago",
  "order_continue": "Realizar pedido",
  "payment_bank": "Elija su banco",
  "payment_loading": "Cargando el pago...",
  "payment_failed": "¡El pago ha fallado!",
  "payment_complete": "¡Pago realizado con éxito! ¡Recibirá la confirmación de su pedido en su bandeja de entrada!",
  "event_nav_customer_information": "Información al cliente",
  "event_customerinformation_title": "Gestione la información de sus clientes",
  "question_add": "Añadir una nueva pregunta",
  "textfield": "Campo de texto",
  "select_box": "Cuadro desplegable",
  "radio_buttons": "Botones de radio",
  "checkboxes": "Casillas de verificación",
  "customer_information_modal_create": "Añadir una pregunta",
  "customer_information_question": "¿Cuál es su pregunta?",
  "customer_information_question_type": "Tipo de pregunta",
  "customer_information_mandatory": "Obligatorio",
  "customer_information_where_to_show": "¿Dónde le gustaría hacer esta pregunta?",
  "customer_information_show_order": "Nivel de pedido",
  "customer_information_show_products": "Nivel de producto",
  "customer_information_modal_edit": "Editar pregunta: {question}",
  "customer_information_which_products": "Seleccione el o los producto(s) en los que desea mostrar la pregunta",
  "customer_information_new_answer": "Nueva respuesta...",
  "customer_information_saved": "¡Preguntas guardadas!",
  "company_name": "Nombre de la empresa",
  "first_name": "Nombre",
  "last_name": "Apellido",
  "address": "Dirección",
  "zip": "Código postal",
  "email": "Correo electrónico",
  "city": "Ciudad",
  "country": "País",
  "dob": "Fecha de nacimiento",
  "mobile": "Teléfono móvil",
  "gender": "Sexo",
  "customer_information_title_general_questions": "Preguntas generales al hacer el pedido",
  "customer_information_title_specific_questions": "Preguntas específicas",
  "dashboard_title": "¡Bienvenido!",
  "pos_not_live": "Este punto de venta está actualmente cerrado, inténtelo más tarde",
  "order_loading": "Cargando su pedido",
  "event_charge_ticket_fee": "Cobrar una tasa de tramitación por ticket a los clientes",
  "pos_not_found": "Punto de venta no encontrado, por favor compruebe su enlace",
  "order_not_found_or_expired": "Pedido no encontrado o caducado",
  "event_continuous": "Este evento es continuo",
  "discountcode_new_modal_title": "Añadir un nuevo código de descuento",
  "discountcode_code": "Código de descuento",
  "discountcode_create_hint": "Una vez que haya creado su código de descuento, podrá establecer información más detallada.",
  "discountcode_modal_edit": "Editar código de descuento: {code}",
  "discountcode_type": "Tipo",
  "discountcode_type_percentage": "Porcentaje",
  "discountcode_type_value": "Valor",
  "discountcode_amount": "Cantidad",
  "discountcode_stock": "Stock",
  "discountcode_is_active": "Es activo",
  "discountcode_saved": "¡Código de descuento guardado!",
  "discountcode_starts_at": "Comienza en",
  "discountcode_ends_at": "Termina en",
  "pos_custom_css": "CSS personalizado",
  "order_id": "ID de pedido",
  "order_full_name": "Nombre del cliente",
  "order_event": "Evento",
  "order_created_at": "Creado en",
  "order_is_paid": "¿Pagado?",
  "order_details": "Detalles",
  "order_products": "Productos pedidos",
  "order_customer_details": "Datos del cliente",
  "order_paid": "¡El pedido está pagado!",
  "order_not_paid": "¡Pedido NO pagado!",
  "order_total": "Total del pedido",
  "order_payment_created_at": "Creado en",
  "order_payment_status": "Estado",
  "order_payment_amount": "Pago",
  "nav_scanners": "Centro de escaneo",
  "scanner_add_modal_title": "Añadir un nuevo escáner",
  "scanner_name": "Nombre",
  "scanner_create_hint": "Utilice un nombre descriptivo para su escáner. Se generará automáticamente una contraseña y un nombre de usuario",
  "scanner_show_login_qr": "Mostrar código QR de inicio de sesión",
  "scanner_qr_code": "Escanee este código QR en la aplicación móvil",
  "close": "Cerrar",
  "scanner_edit": "Editar escáner",
  "scanner_updated": "El escáner está actualizado.",
  "pos_no_group": "Tickets sin grupo",
  "order_notes": "Notas",
  "ticket_not_generated": "¡Ticket no generado!",
  "ticket_generated": "Generado",
  "ticked_scanned": "Escaneado",
  "ticket_view": "Ver ticket",
  "ticket_generate": "Generar ticket nuevo",
  "order_create_note": "Crear una nueva nota",
  "order_expires_in": "Si no completa su pedido a tiempo, se cancelará automáticamente. Dispone de {timeLeft} para completar su pedido",
  "ticket_not_found": "Ticket no encontrado",
  "order_no_payment_method": "No se ha seleccionado ningún método de pago",
  "payment_successful": "¡Pago realizado con éxito!",
  "unknown": "Desconocido",
  "email_order_confirmation": "Confirmación del pedido enviado",
  "audit_show_context": "Mostrar detalles",
  "email_content": "Contenido del correo electrónico",
  "email_ticket_sent": "Ticket enviado por correo electrónico",
  "assign_tickets_title": "¿Quién debe recibir las entradas?",
  "assign_tickets_hint": "Hemos recibido su pedido y su pago se ha completado. Lo único que tiene que hacer antes de poder disfrutar del evento es asignar sus entradas",
  "assign_tickets_send": "Asignar",
  "assign_ticket_self": "rellenar yo mismo",
  "assign_ticket_sent": "enviar invitación",
  "ticket_claim": "Reclamar ticket",
  "customer_full_name": "Nombre completo",
  "customer_form_title": "Introduzca sus datos personales",
  "error_try_again": "Se ha producido un error, inténtelo de nuevo",
  "error_select_payment_method": "Seleccione un método de pago",
  "product_type": "Tipo de producto",
  "product_is_upsell": "Producto de venta adicional sin ticket electrónico",
  "product_create_eticket": "¿Quiere generar un ticket electrónico?",
  "product_is_not_upsell": "Ticket electrónicos",
  "product_price": "Precio",
  "product_stock": "Capacidad",
  "product_specific_sale_times": "Tiempo específico de venta",
  "product_no_products": "Todavía no se ha añadido ningún producto",
  "discountcode_add_to_cart": "Añadir código de descuento",
  "discount_code_claim": "Reclamar",
  "discountcode_invalid": "Este código de descuento no es válido.",
  "cart_discount": "Descuento {code}",
  "event_module_name_marketing": "Marketing",
  "event_module_name_organise": "Organizar",
  "event_print_visitor_list": "Lista de visitas",
  "print": "Imprimir",
  "order_pick_timeslot": "Elegir franja horaria",
  "email_ticket_assigned": "ticket de correo electrónico asignado",
  "order_actions": "Acciones",
  "order_cancel": "Cancelar el pedido",
  "order_refund": "Orden de reembolso",
  "order_is_cancelled": "¡Este pedido está cancelado!",
  "order_cancelled": "El pedido está cancelado",
  "order_log": "Registro",
  "order_is_refunded": "Pedido reembolsado",
  "user_added": "¡Usuario añadido!",
  "company_updated": "¡Datos de la empresa actualizados!",
  "user_role": "función",
  "user_updated": "¡Datos del usuario actualizados!",
  "login_invalid": "Ingreso inválido, por favor intente de nuevo",
  "no_product_group": "Productos sin grupo",
  "pos_status": "Estado",
  "pos_no_product_category": "Productos sin categoría",
  "company_invoice_prefix": "Prefijo de la factura",
  "yes": "Sí",
  "no": "No",
  "order_number": "Número de pedido",
  "order_resend_confirmation": "Reenvío de tickets",
  "optin": "Actualizaciones por correo electrónico",
  "customer_optin": "Deseo recibir información actualizada sobre este organizador.",
  "customer_optin_iams": "Sí, me gustaría recibir correos electrónicos de IAMS para tener la oportunidad de ganar premios y experiencias VIP.",
  "shop_questions_event_hint": "Nuestro servicio de atención al cliente está siempre a su disposición. ¡Sólo tiene que escribir un correo electrónico o llamar al siguiente número!",
  "shop_questions_tickets_hint": "Si tiene alguna pregunta, siempre puede ponerse en contacto con Fairtix. ¡Sólo tiene que escribir un correo electrónico o llamar al siguiente número!",
  "shop_questions_event": "¿Preguntas sobre el evento?",
  "shop_questions_tickets": "¿Preguntas sobre los tickets?",
  "order_expired": "Su pedido ha caducado, por favor, vuelva a empezar",
  "layout_settings": "Configuración del diseño",
  "layout_primary_color": "Color primario",
  "layout_secondary_color": "Color secundario",
  "layout_secondary_backgroundColor": "Color de fondo primario",
  "layout_colors": "Colores del diseño",
  "layout_header": "Cabecera",
  "layout_logo": "Logotipo",
  "layout_header_backgroundColor": "Color de fondo de la cabecera",
  "company_layout": "Configuración del diseño",
  "add": "Añadir",
  "layout_updated": "¡Diseño actualizado!",
  "shop_tickets": "Tickets",
  "shop_personal_details": "Datos personales",
  "shop_additional_products": "Productos adicionales",
  "shop_timeslot": "Franja horaria",
  "shop_pay": "Pago",
  "cart_clear": "Despejar el carrito",
  "invalid_discount_code": "Código de descuento inválido",
  "access_denied": "acceso denegado",
  "discountcode_already_exists": "Este código de descuento ya existe.",
  "end_before_start_date": "La fecha de finalización no puede ser anterior a la fecha de inicio",
  "scanner_token_invalid": "El token para el escáner no es válido",
  "ticket_invalid": "El ticket no es válido",
  "ticket_change_owner": "Cambiar el dueño",
  "product_max_exceeded": "Demasiados productos en el pedido, la cantidad es superior al límite de productos por pedido",
  "order_not_paid_error": "No se puede completar la acción, el pedido no está pagado",
  "product_not_live": "El producto no está activo",
  "product_not_eticket": "No se puede añadir el pedido del producto. No es un producto adicional",
  "product_out_of_stock": "El producto está agotado",
  "product_stock_unlimited_icon": "∞",
  "product_stock_unlimited_text": "Unlimited",
  "product_not_unlimited_stock": "product is not unlimited on stock",
  "ticket_already_scanned": "El ticket ya está escaneado",
  "invalid_ticket_entrance": "Entrada no válida para el ticket",
  "timeslot_event_time_mismatch": "La franja horaria no está en el rango de inicio/fin del evento",
  "timeslot_overlap": "No se pueden crear franjas horarias superpuestas",
  "token_expired": "Sesión expirada, por favor, inicie sesión",
  "timeslot_too_many_spots": "No se puede crear una franja horaria: No hay suficientes productos para esta cantidad",
  "assign_tickets_select": "¿Qué entradas le gustaría enviar?",
  "assign_tickets_myself": "Asignarme a mí mismo",
  "assign_tickets_by_invite": "Enviar invitaciones",
  "assign_tickets_continue": "Enviar y continuar",
  "tickets_fill_completed": "Tickets completadas",
  "tickets_fill_title": "Completar los tickets ({todo}/{done})",
  "phone": "Número de teléfono",
  "customer_fields_saved": "Campos de clientes guardados",
  "customer_country": "País",
  "customer_house_nr": "House no",
  "country_de": "Alemania",
  "country_nl": "Países Bajos",
  "country_es": "España",
  "country_be": "Bélgica",
  "customer_form_custom_questions": "Responda a las siguientes preguntas porfavor",
  "errors_please_select": "Seleccione una opción porfavor",
  "order_thank_you": "¡Gracias por su pedido #{order_number}",
  "order_thank_you_text": "Su pedido se ha completado.",
  "order_thank_you_btn_ticket_download": "Descargar tickets",
  "assign_tickets_next": "Siguiente",
  "order_status_number": "Estado del pedido #{order_number}",
  "order_status_event": "Evento: {name}",
  "order_status_paid": "Pagado",
  "order_status_ticket_not_assigned": "Aún no registrado",
  "order_status_put_on_name": "Asignar nombre",
  "order_status_product_refunded": "Reembolsado en {refunded_at}",
  "order_status_product_cancelled": "Cancelado",
  "order_status_product_invited_at": "Invitados a {invited_at}",
  "order_status_ticket_generating": "Se está generando un ticket",
  "order_status_alert_refunded": "Reembolso íntegro de su pedido",
  "order_status_alert_cancelled": "Su pedido ha sido cancelado",
  "order_status_alert_not_paid": "Su pago no se ha efectuado o no ha sido aceptado por nuestro proveedor de servicios de pago, realice un nuevo pedido.",
  "order_status_alert_pending": "Su pago aún no se ha efectuado, nuestro proveedor de servicios de pago comprobará este pago manualmente. Esto puede tardar varias horas.",
  "ticket_reminded_at": "Recordado en",
  "ticket_invited_at": "Invitado en",
  "ticket_claimed_at": "Reclamado en",
  "ticket_not_claimed": "Ticket no reclamado",
  "ticket_download": "Descargar ticket",
  "ticket_send_reminder": "Enviar recordatorio",
  "ticket_reminder_sent": "¡Recordatorio enviado!",
  "customer_email_suggestion": "¿Quiere decir {full}?",
  "order_status_your_tickets": "Tus tickets",
  "order_open_customer_status": "Abrir la página de estado del cliente",
  "ticket_change": "Cambiar",
  "cart_terms_conditions_first": "Estoy de acuerdo con los",
  "cart_terms_conditions": "Al hacer clic en el botón 'Continuar' confirma que ha leído y está de acuerdo con los <a href='{url}' target='_blank'>Términos y condiciones</a> & <a href='https://fairtix.io/es/privacy-policy' target='_blank'>Política de Privacidad</a> de Fairtix.",
  "must_agree_with_tos": "Debe aceptar los Términos y Condiciones para poder continuar.",
  "product_max_buy": "Compra máxima por pedido",
  "product_description": "Descripción",
  "actions": "Acciones",
  "product_vat_percentage": "IVA %",
  "product_image": "Imagen",
  "template_qr": "Posición del código QR",
  "top": "Arriba",
  "left": "Izquierda",
  "width": "Anchura",
  "height": "altura",
  "template_texts": "Elementos de texto",
  "template_texts_hint": "Puedes colocar varios trozos de texto",
  "template_add_text": "Añadir bloque de texto",
  "template_background": "Imagen de fondo",
  "template_save": "Guardar plantilla",
  "generate_preview": "Descargar vista previa",
  "nav_ticket_templates": "Plantillas de tickets",
  "ticket_template_background": "Fondo del ticket",
  "template_background_hint": "El archivo que subas debe tener 1240x1755 en píxeles, a 72DPI",
  "customer_gender_other": "otros",
  "ticket_template_updated": "¡Plantilla de entradas actualizada!",
  "template_text_block": "Texto",
  "template_position_hints": "La página tiene 595 por 842 'puntos', cualquier cosa fuera de este rango no se mostrará en el ticket",
  "ticket_template_name": "Nombre de la plantilla",
  "error_name": "Nombre inválido",
  "event_ticket_template": "Plantilla de tickets",
  "event_has_donation_product": "El evento no puede tener más de un producto de Donación",
  "whatsapp_message": "Reclame su entrada para el {event} aquí porfavor: {link}",
  "event_updated": "¡Detalles del evento actualizados!",
  "event_not_live": "El evento no está abierto a la venta en este momento, inténtelo más tarde",
  "event_is_archived": "El evento se ha archivado y ya no se puede editar",
  "event_passed": "El evento no está en línea",
  "product_sale_starts_at": "La venta comienza en",
  "product_sale_ends_at": "La venta termina en",
  "error_page_not_found": "Página no encontrada",
  "create_template": "Crear plantilla",
  "template_modal_create": "Crear una nueva plantilla",
  "template_name": "Nombre",
  "error_is_upsell": "Elija su tipo de producto",
  "error_vat_percentage": "Rellene un porcentaje de IVA",
  "error_price": "Rellene un precio",
  "error_stock": "Rellene una cantidad de stock",
  "error_status": "Elija un estado",
  "ticket_confirmation_resent": "Se han reenviado las entradas",
  "layout_cart": "Diseño del carro",
  "layout_cart_backgroundcolor": "Color de fondo",
  "layout_cart_color": "Color del texto",
  "layout_cart_product_title_color": "Color del título del producto",
  "layout_cart_product_subtext_color": "color del subtexto del producto",
  "layout_cart_product_price_color": "Precio del producto color",
  "layout_cart_button_backgroundColor": "Color de fondo del botón",
  "layout_cart_button_color": "Color del botón",
  "layout_cart_sidebar": "Barra lateral del carro",
  "layout_cart_sidebar_backgroundColor": "Color de fondo",
  "layout_cart_sidebar_color": "Color del texto",
  "layout_cart_sidebar_button_backgroundColor": "Color de fondo del botón",
  "layout_cart_sidebar_button_color": "Color del texto del botón",
  "layout_cart_product_group_backgroundColor": "Color de fondo del grupo",
  "layout_cart_product_group_textColor": "Color del texto del grupo",
  "layout_top_bar": "Diseño de la barra superior",
  "layout_top_bar_title_color": "Color del título",
  "layout_stepper_backgroundColor": "Color de fondo del escalón",
  "layout_stepper_color": "Color del texto del escalón",
  "layout_info_blocks": "Diseño de los bloques de información",
  "layout_info_blocks_titleColor": "Color del título",
  "layout_info_blocks_color": "Color del texto",
  "layout_info_blocks_backgroundColor": "Fondo",
  "layout_stepper_done_backgroundColor": "Escalón realizado color de fondo",
  "layout_stepper_done_color": "Escalón realizado color del texto",
  "view_pos_title": "Resumen de productos para {event_name}",
  "pos_personal_details_title": "Datos personales",
  "pos_timeslot_title": "Resumen de franjas horarias",
  "pos_payment_method_title": "Métodos de pago",
  "pos_allow_donation_question": "¿Permitir donaciones?",
  "order_view_order_details_title": "Asigne su(s) ticket(s)",
  "order_view_assign_title": "Asigne su(s) ticket(s)",
  "order_thank_you_title": "Gracias",
  "order_status_title": "Resumen del pedido",
  "ticket_changed": "¡Ticket cambiado!",
  "ticket_changed_text": "El ticket ha sido cambiado y será enviado por correo electrónico en breve.",
  "view_pos_cart_title": "Elige tus tickets",
  "tickets_assigned_email_sent": "¡Correo electrónico de invitación enviado con éxito!",
  "backend_title_login": "Panel de control Fairtix",
  "backend_title_dashboard": "Panel de control",
  "backend_title_order_overview": "Resumen del pedido",
  "backend_title_order_detail": "Detalle del pedido {order_number}",
  "backend_title_events_overview": "Resumen de eventos",
  "backend_title_events_manage": "Gestionar el evento",
  "backend_title_events_products": "Productos de eventos",
  "backend_title_events_timeslots": "Franjas horarias del evento",
  "backend_title_events_customer_information": "Información del cliente del evento",
  "backend_title_events_pos": "Puntos de venta del evento",
  "backend_title_events_visitor_list": "Lista de visitantes del evento",
  "backend_title_reports": "Informes",
  "backend_title_discountcodes": "Resumen de los códigos de descuento",
  "backend_title_ticket_templates": "Plantillas de tickets",
  "backend_title_edit_ticket_templates": "Editar la plantilla del ticket",
  "backend_title_manage_company": "Gestionar la empresa",
  "report_genders_unkown": "Desconocido",
  "report_genders_f": "Mujeres",
  "report_genders_m": "Hombres",
  "report_genders_o": "Otros",
  "report_cities_unkown": "Desconocido",
  "report_paid_orders": "Pedidos pagados",
  "report_tickets_sold": "Billetes emitidos",
  "report_tickets_claimed": "Tickets reclamados",
  "report_total_revenue": "Ingresos totales",
  "report_sales_per_day": "Ventas por día",
  "report_sales_per_day_cumulative": "Ventas acumuladas",
  "report_tickets_sold_per_type": "Entradas vendidas por tipo",
  "report_gender": "Sexos",
  "report_cities": "Ciudades",
  "report_payment_methods": "Métodos de pago",
  "report_tickets": "Tickets",
  "report_age": "Edades",
  "report_event": "Evento",
  "report_date_range_start": "Fecha de inicio",
  "report_date_range_end": "Fecha de finalización",
  "report_filter_btn": "Filtro",
  "ticket_templates": "Plantillas de tickets",
  "ticket_customer_not_set": "Cliente no encontrado",
  "order_payment_pending": "Cuando recibamos su pago, le enviaremos un correo electrónico con un enlace para reclamar sus entradas.",
  "export_orders": "Pedidos de exportación",
  "language_en": "Inglés",
  "language_de": "Alemán",
  "language_nl": "Holandés",
  "orders_export": "Exportar pedidos a CSV",
  "export_event_name": "Nombre del evento",
  "export_order_number": "Número de pedido",
  "export_total_price": "Precio total",
  "export_discount": "Corrección",
  "export_order_payment_fee": "Gastos administrativos de pago",
  "export_order_payment_fee_vat": "Gastos administrativos de pago IVA",
  "export_order_payment_fee_vat_perc": "Gastos administrativos de pago IVA %",
  "export_ticket_fee_total": "Gastos de gestión de las entradas",
  "export_ticket_fee_vat": "Gastos de gestión de las entradas IVA",
  "export_ticket_fee_vat_perc": "Gastos de gestión de las entradas IVA %",
  "export_product_number": "Número de producto",
  "export_product_price": "Precio del producto",
  "export_product_price_vat": "Precio del producto IVA",
  "export_product_price_vat_perc": "Precio del producto IVA %",
  "export_product_service_fee": "Gastos de administración del servicio de productos",
  "export_product_service_fee_vat": "Gastos de administración del servicio de productos IVA",
  "export_product_service_fee_vat_perc": "Gastos de administración de los servicios de productos BTW %",
  "export_order_payment_method": "Método de pago",
  "export_customer_first_name": "Nombre del cliente",
  "export_customer_last_name": "Apellido del cliente",
  "export_customer_company_name": "Nombre de la empresa del cliente",
  "export_customer_email": "Correo electrónico del cliente",
  "export_customer_address": "Dirección del cliente",
  "export_customer_zip": "Código postal del cliente",
  "export_customer_city": "Ciudad del cliente",
  "export_customer_country": "País del cliente",
  "export_customer_gender": "Sexo del cliente",
  "export_customer_optin": "Optin del cliente",
  "export_customer_phone": "Número de teléfono del cliente",
  "export_product_id": "ID del producto",
  "export_product_group": "Grupo de productos",
  "export_product_name": "Nombre del producto",
  "export_product_type": "Tipo del producto",
  "export_settings_from": "Fecha de inicio",
  "export_settings_to": "Fecha de finalización",
  "export_settings_fields": "Campos a exportar",
  "export_settings_check_all": "Seleccionar todos los campos",
  "orders_export_make": "Hacer la exportación",
  "error_from": "No se ha seleccionado ninguna fecha de inicio",
  "error_to": "No se ha seleccionado ninguna fecha de finalización",
  "error_fields": "No hay campos seleccionados",
  "timeslot_deleted": "¡Tarjeta de tiempo eliminada!",
  "timeslot_already_in_orders": "No se puede eliminar la franja horaria, ya ha sido solicitada",
  "cart_vat": "IVA",
  "cart_product": "Producto",
  "cart_price": "Cantidad",
  "company_vat_percentage": "IVA por defecto de la empresa",
  "max": "Máximo",
  "not_set": "No se ha establecido",
  "template_title": "Editar plantilla: {name}",
  "order_discount": "Descuento",
  "ticket_cancelled": "Cancelado",
  "order_status_cancelled": "Cancelado",
  "order_status_refunded": "Reembolsado",
  "ticket_cancel": "Cancellar",
  "order_detail_ticket_cancelled": "Ticket cancelado con éxito",
  "order_detail_modal_cancel_order_title": "Cancelar el pedido: #{order}",
  "order_detail_order_cancelled": "Pedido cancelado",
  "order_detail_cancel_order": "Cancelar el pedido",
  "order_detail_cancel_order_confirmation": "¿Está seguro de que quiere cancelar este pedido?",
  "order_detail_modal_refund_order_title": "Orden de reembolso: #{order}",
  "order_detail_refund_order_confirmation": "¿Está seguro de que quiere reembolsar este pedido?",
  "order_detail_refund_order": "Reembolso",
  "order_detail_refund_order_amount": "Cantidad",
  "order_detail_refund_greater_error": "El importe no debe ser superior a:  ",
  "order_detail_refund_less_error": "El importe debe ser positivo",
  "order_detail_order_refunded": "El pedido ha sido reembolsado con éxito",
  "order_refund_invalid_amount_error": "Importe no válido",
  "order_detail_modal_resent_tickets_title": "Enviar la confirmación del pedido: #{order}",
  "order_detail_resent_tickets_confirmation": "¿Estás seguro de que quieres reenviar las entradas?",
  "order_detail_resent_confirmation_tickets": "Enviar entradas",
  "payment_started": "Pago iniciado",
  "order_refunded": "Pedido reembolsado",
  "order_detail_modal_send_mail": "Informar al cliente con un correo electrónico",
  "order_detail_mail_receiver": "Receptor",
  "order_detail_mail_subject": "Asunto",
  "order_detail_mail_message": "Mensaje",
  "mail_subject_cancel_order": "{first_name}, su pedido ha sido cancelado",
  "email_order_cancelled": "Pedido anulado",
  "mail_subject_refund_order": "{first_name}, su pedido ha sido reembolsado",
  "email_order_refunded": "Pedido reembolsado",
  "order_customer_answers": "Respuestas del cliente",
  "delete_entry": "¿Realmente quieres eliminar?",
  "product_had_been_ordered": "El producto había sido encargado",
  "product_modal_delete": "Eliminar el producto",
  "product_delete_confirmation": "¿Realmente quieres eliminar?",
  "product_has_been_deleted": "El producto ha sido eliminado",
  "event_event_type": "Tipo de evento",
  "user_role_user": "Usuario",
  "user_role_company_admin": "Administrador de la empresa",
  "order_detail_payment_method": "Método de pago",
  "pos_in_test_mode": "Este punto de venta está en modo de prueba",
  "order_test_paid": "Pedido de prueba",
  "product_successfully_ordered": "Éxito",
  "manage_company_without_vat": "Estos precios son sin IVA",
  "product_calculate_service_fee": "Traspaso de los costes administrativos al cliente",
  "product_companies_ticket_fee": "El precio de la entrada de su empresa es de {ticket_fee_incl}, IVA incluido",
  "order_overview_show_expired": "Mostrar pedidos caducados",
  "scan_start_date": "Inicie",
  "scan_start_time": "Inicie",
  "scan_end_date": "Finalizar",
  "scan_end_time": "Finalizar",
  "scanner_description": "Omschrijving (Bijv: Hoofd ingang)",
  "scan_operation_session_modal_delete": "Borrar la confirmación de la sesión",
  "scan_operation_session_name": "Nombre de la sesión",
  "scan_operation_session_modal_edit": "Cambiar los detalles de la sesión",
  "scanner_modal_delete": "Eliminar el escáner",
  "scanner_username": "Nombre de usuario",
  "scanner_password": "Contraseña",
  "session_name": "Nombre de la sesión",
  "scanner_modal_edit": "Cambiar los detalles del escáner",
  "next": "Siguiente",
  "scan_sessions": "Sesiones de exploración",
  "scan_enable_outgoing_hint": "Escanear al visitante al salir",
  "scan_enable_outgoing": "Activar los escaneos salientes",
  "scan_test_mode_hint": "Conectar el modo de prueba",
  "scan_test_mode": "Modo de prueba",
  "scanner_manage_title": "Gestión de los datos del escáner",
  "nav_scan_operations": "Operaciones de escaneo",
  "previous": "Anteriormente",
  "scan_operation_session_configure_products": "Configurar productos",
  "sessions": "Sesiones",
  "scan_operation_products": "Productos",
  "scan_operation_session_configure_scanners": "Configuración de los escáneres",
  "finish": "Acabado",
  "scan_operation_overview_event": "Evento: {event_name}",
  "scan_operation_overview_outgoing_scans": "Escaneos de salida:",
  "scan_operation_overview_outgoing_test_mode": "Modo de prueba:",
  "scan_operation_overview_outgoing_enabled": "Activado",
  "scan_operation_overview_outgoing_disabled": "Discapacitados",
  "scan_operation_overview_outgoing_false": "Falso",
  "scan_operation_overview_outgoing_true": "Donde",
  "scan_operation_overview_scanners": "Escáneres",
  "scan_operation_overview_sessions": "Sessues",
  "scan_operation_overview_edit": "Cambiar",
  "scan_operation_overview_product_configuration": "Configuración del producto",
  "scan_operation_overview_scanner_configuration": "Configuración del escáner",
  "scan_operation_overview_for": "Resumen de las operaciones de exploración para: {event_name}",
  "backend_title_scan_operation_manage": "Gestionar la operación de escaneo",
  "backend_title_scan_operation_summary": "Resumen de la operación de exploración",
  "backend_title_scan_operation_product_configuration": "Configuración del producto",
  "backend_title_scan_operation_scanner_configuration": "Configuración del escáner",
  "date_format": "dd-mm-yyyy",
  "export_no_results": "No se encuentran resultados en este plazo",
  "ticket_customer_not_assigned": "Titular del billete no asignado",
  "copy_ticket_link": "Copiar enlace",
  "ticket_assign": "Asignación de entradas",
  "ticket_assigned_explenation": "{customer_first_name} le ha comprado una entrada para el evento {event_name}. Reclame su entrada rellenando el siguiente formulario.",
  "scan_operation_event": "Evento",
  "scan_operation_status": "Estatus",
  "scan_operation_users": "Cantidad de escáneres",
  "scan_operation_actions": "Acciones",
  "scan_operation_add_modal_title": "Realizar la operación de escaneo",
  "select_event": "Evento",
  "scan_operation_create_hint": "Elija el evento para el que va a realizar una operación de escaneo",
  "event_module_name_box_offices": "Taquillas",
  "event_nav_box_offices": "Taquillas",
  "event_box_office_create": "Crear una nueva taquilla",
  "event_box_office_create_name": "Nombre de la taquilla",
  "event_box_office_name": "Taquillas",
  "event_box_office_modal_edit": "Editar taquilla",
  "event_box_office_products": "Seleccione los productos mostrados en la taquilla",
  "event_box_office_payment_methods": "Seleccione los métodos de pago que se muestran",
  "box_office_updated": "La taquilla ha cambiado con éxito",
  "event_box_office_check_overrule": "Anulación de precios",
  "user_box_office": "Es la taquilla",
  "box_office_choose_event_title": "Elija un evento para el que desee iniciar la taquilla",
  "box_office_choose_box_office_title": "Elija la taquilla que desea iniciar para el evento: {event_name}",
  "box_office_place_order_price": "Precio",
  "box_office_place_order_available": "Disponible",
  "box_office_place_order_sold_out": "Agotado",
  "box_office_place_order_save_settings_success": "Éxito",
  "box_office_place_order_customer_details": "Datos del cliente",
  "box_office_place_order_fill_customer_details": "Rellenar los datos del cliente",
  "box_office_place_order_choose_payment": "Elija el método de pago preformado",
  "box_office_place_order_payment_pin": "Pin",
  "box_office_place_order_payment_cash": "Efectivo",
  "box_office_place_order_discount_enter": "Enter",
  "box_office_place_order_remove_discount": "Eliminar el descuento",
  "box_office_place_order_empty_cart": "Cesta vacía",
  "box_office_place_order_amount_of_products": "Cantidad de productos:",
  "box_office_place_order_subtotal": "Subtotal:",
  "box_office_place_order_total": "Total:",
  "box_office_place_order_discount": "Descuento:",
  "box_office_place_order_which_product_to_show": "¿Qué producto(s) le gustaría mostrar?",
  "box_office_place_order_place_order": "Hacer un pedido",
  "event_default_group": "Default Group",
  "event_box_office_use_all_stock": "Utilización de las existencias de billetes no vendidos",
  "box_office_place_order_customer_has_to_pay": "El cliente tiene que pagar",
  "box_office_place_order_given_by_customer_in": "Dado por el cliente en",
  "box_office_place_order_return_to_customer_in": "Devolución al cliente en",
  "box_office_order_history_order_number": "Número de pedido",
  "box_office_order_history_order_placed": "Pedido realizado",
  "box_office_order_history_payment_method": "Forma de pago",
  "box_office_order_history_customer": "Cliente",
  "box_office_order_history_products": "Productos",
  "box_office_order_history_total_price": "Precio total",
  "unkown": "Desconocido",
  "add_discount": "Add discount",
  "box_office_place_save_settings_success": "Cambios guardados",
  "order_overview_box_office": "Taquilla",
  "order_overview_online": "En línea",
  "order_type": "Tipo de pedido",
  "box_office_order_history_title": "Historial de pedidos",
  "box_office_place_order_discount_to_high": "El descuento no puede superar el importe total",
  "event_show_archived": "Mostrar eventos archivados",
  "order_overview_show_box_office_orders": "Pedidos de taquilla de espectáculos",
  "report_box_office": "Incluir los pedidos de taquilla",
  "export_to_email": "Enviar la exportación a",
  "error_email": "El correo electrónico es necesario",
  "export_order_success": "Su descarga estará lista pronto, el enlace se enviará al correo electrónico proporcionado",
  "role_is_required": "El papel es necesario",
  "password_is_required": "Se requiere una contraseña",
  "email_is_required": "El correo electrónico es obligatorio",
  "username_is_required": "El nombre de usuario es obligatorio",
  "box_office_no_payment_method_chosen": "No se ha seleccionado ningún método de pago",
  "box_office_no_products_chosen": "No hay productos seleccionados",
  "product_remove_image": "Quitar la imagen",
  "order_ticket_scanned_at": "Billete escaneado en",
  "order_ticket_not_yet_scanned": "Todavía no se ha escaneado",
  "order_details_edit_customer_data": "Editar los datos del cliente",
  "order_details_edit_customer_success_message": "Los datos de los clientes se actualizan",
  "customer_already_exists": "El cliente ya existe",
  "scan_operation_show_archived": "Mostrar la operación de exploración archivada",
  "no_results_have_been_found": "No se han encontrado resultados",
  "error_ticket_template_id": "No se ha elegido el modelo de billete",
  "test_payment": "Pago de la prueba",
  "layout_top_bar_date_color": "Color del texto de la fecha",
  "layout_stepper_hint_color": "Color del texto de sugerencia",
  "pos_product_expired": "Expirado",
  "product_min_buy": "Compra mínima por pedido",
	"product_amount_is_less_than_minimum_amount": "La cantidad de producto es inferior a la cantidad mínima",
	"min_buy_should_be_less_than_max_buy": "La compra mínima debe ser menor que la compra máxima",
	"product_multi_day_ticket": "Billete de varios días",
	"dashboard_events_tickets_sold": "Entradas incluidas {guest_list_number} lista de invitados",
	"dashboard_events_today": "Hoy",
	"dashboard_events_last_7_days": "Últimos 7 días",
	"dashboard_events_total_revenue": "Ingresos totales:",
  "duplicate": "Duplicado",
  "event_duplicate_event": "Evento duplicado",
  "event_new_name": "Nuevo nombre del evento",
  "event_duplicate_choose_products_to_copy": "Elija qué producto(s) desea copiar",
  "event_duplicate_point_of_sales": "URLs de puntos de venta",
  "select_all": "Seleccionar todo",
  "unselect_all": "Deseleccionar todo",
  "event_scan_operation_session_date_to_change": "Hay que cambiar la fecha y la hora de la sesión de exploración",
  "event_name_has_to_be_changed": "Hay que cambiar el nombre del evento",
  "customer_support_free_search": "Búsqueda gratuita",
  "customer_support_search": "Buscar en",
  "customer_support_reset_filter": "Reiniciar el filtro",
  "customer_support_filters": "Filtros",
  "customer_support_company": "Empresa:",
  "customer_support_event": "Evento:",
  "customer_support_payment_status": "Estado de los pagos:",
  "customer_support_center": "Centro de atención al cliente",
  "order_status_new": "Nuevo",
  "order_status_pending": "Pendiente",
  "user_role_customer_support": "Asistencia al cliente",
  "no_data_to_show": "No hay datos que lo demuestren",
  "submit": "Submit",
  "pos_show_in_overview": "Mostrar el punto de venta en el resumen del evento",
  "login_username": "Nombre de usuario",
  "scan_operation_terminal_button": "Terminal de escaneo",
  "scanner_terminal_event": "Terminal de escaneo para",
  "dashboard_events_scans": "Escáneres:",
  "dashboard_total_visitors_inside": "visitantes dentro",
  "dashboard_scanned": "Escaneado",
  "dashboard_left_to_scan": "Para escanear",
  "dashboard_box_office_entries": "Entradas en taquilla",
  "opening_hours_hourly": "por hora",
  "opening_hours_all_day": "todo el día",
  "opening_hours_create": "Añadir hora de apertura",
  "opening_hours_day_of_week": "día",
  "opening_hours_opens_at": "se abre de",
  "opening_hours_closes_at": "se cierra a",
  "opening_hours_spots": "manchas",
  "opening_hour_interval": "intervalo",
  "opening_hour_create": "Nuevo",
  "edit_opening_hours_day": "Cambiar el horario de apertura para el día",
  "opening_hours_adjust": "Cambiar el día",
  "day_adjusted": "Cambio de horario para el día",
  "event_timeslots_actions": "Actions",
  "error_opens_at": "Se abre en no se rellena correctamente",
  "error_closes_at": "Se cierra en no se rellena correctamente",
  "error_spots": "Las plazas no se llenan",
  "error_interval": "No se elige el intervalo",
  "order_pick_date": "Elige tu fecha",
  "order_timeslot": "Horario",
  "invalid_opening_hour": "Hora de apertura no válida",
  "event_ticket_template_product_tooltip": "La elección de una plantilla anula la plantilla de entradas por defecto configurada para el evento para este producto específico.",
  "company_show_kvk_on_pos": "Mostrar el número de la cámara de comercio en la tienda",
  "shop_chamber_of_commerce_number": "Cámara de comercio",
  "my_company_invoice_title": "Configuración automática de la factura",
  "my_company_invoice_automatic_invoicing": "Activar la facturación automática",
  "my_company_invoice_automatic_invoicing_test_mode": "Modo de prueba (sin pagos reales)",
  "my_company_invoice_vat_shifted": "Hacer que las facturas tengan el IVA cambiado",
  "my_company_invoice_anti_dating": "Antigüedad de los pagos de Pay.nl",
  "my_company_invoice_include_payout_summary": "Incluir informe de resumen de pagos",
  "my_company_invoice_include_fairtix_invoice": "Incluir la factura de Fairtix para el cliente",
  "my_company_invoice_generate_fairtix_invoice": "Generar una factura Fairtix para el cliente",
  "my_company_invoice_include_detailed_explanation": "Incluir un informe resumido detallado",
  "my_company_invoice_generate_detailed_explanation": "Generar un informe resumido detallado",
  "my_company_invoice_set_off_invoices": "Compensar la factura de pago con la factura de Fairtix",
  "my_company_invoice_generate_payout_summary": "Generar informe de resumen de pagos",
  "my_company_invoice_payout_frequency": "Frecuencia de pago",
  "my_company_invoice_max_payment_period": "Plazo máximo de pago (en días)",
  "my_company_invoice_payout_delay": "Retraso en el pago después del evento (en días)",
  "my_company_invoice_receive_method": "Método de recepción",
  "event_deleted": "Evento eliminado!",
  "ticket_claim_copy_order_data": "Copiar los datos personales del pedido",
  "pos_overview_read_less": "Leer más",
  "pos_overview_read_more": "Leer más",
  "manage_event_image": "Imagen (530x340 píxeles)",
  "manage_event_remove_image": "Quitar la imagen",
  "manage_event_image_tooltip": "Esta imagen se mostrará en el resumen del evento",
  "pos_sale_ends_in_days_and_hours": "La venta termina en {days} días y {hours} horas",
  "pos_sale_ended_at": "La venta terminó en",
  "pos_sale_ends_in_hours": "La venta termina en {hours} horas",
  "template_background_jpg_hint": "Sólo se permite subir JPGs como imagen de fondo",
  "event_has_orders": "El evento tiene órdenes",
	"company_settings": "Configuración",
	"company_send_order_notifications": "Enviar notificaciones de pedidos",
	"company_send_order_notifications_email": "Dirección de correo electrónico que desea recibir notificaciones",
	"reports_include_archived_events": "Incluir eventos archivados",
	"pos_sale_ends_in_minutes": "La venta termina en {minutes} minuto(s)",
	"pos_sale_ends_in_months_days_and_hours": "La venta termina en {months} mes(es), {days} día(s) y {hours} hora(s)",
	"pos_sale_ends_in_months_days": "La venta termina en {months} mes(es) y {days} día(s)",
	"pos_sale_ends_in_months": "La venta termina en {months} mes(es)",
	"dashboard_sold_tickets": "Entradas vendidas para: {event}",
    "add_attendees": "Añadir asistentes",
    "guest_list_add_attendees": "Enviar las entradas de la lista de invitados",
    "guest_list_choose_tickets": "Elija la(s) entrada(s)",
    "guest_list_total_worth": "Valor total:",
    "guest_list_total_items": "Total de artículos:",
    "guest_list_order_data": "Datos del pedido",
    "quest_list_populate_tickets_with_customer_data": "Rellenar los tickets con los datos del cliente",
    "guest_list_todo_next_send_invite_to_claim_tickets_description": "El propietario del pedido recibirá un correo electrónico con un enlace donde se pueden asignar y reclamar todas las entradas",
    "guest_list_todo_next_send_invite_to_claim_tickets": "Enviar invitación para reclamar entradas",
    "guest_list_todo_next_send_all_tickets_to_order_owner": "Enviar todas las entradas al propietario del pedido",
    "guest_list_todo_next_send_all_tickets_to_order_owner_description": "El propietario del pedido recibirá un correo electrónico en el que se adjuntan todas las entradas en formato PDF por separado",
    "guest_list_todo_next_place_order_without_sending_tickets_description": "El pedido se realizará sin enviar ningún billete",
    "guest_list_todo_next_place_order_without_sending_tickets": "Hacer un pedido sin enviar billetes",
    "guest_list_no_payment_needed": "No es necesario pagar",
    "guest_list_paid_with_cash": "Pagado con dinero en efectivo",
    "guest_list_send_order_confirmation": "Enviar la confirmación del pedido por correo electrónico",
    "guest_list_order_saved_successfully": "Entradas añadidas correctamente",
    "guest_list_order_saved_successfully_desc": "Se ha creado el pedido y se le han añadido las entradas. La persona especificada ha recibido un correo electrónico con los detalles.",
    "guest_list_not_all_customer_details_filled": "No se han rellenado todos los datos del cliente",
	"order_overview_free_tickets": "Pedido gratuito",
    "order_overview_manual_orders": "Pedido manual",
    "guest_list_tickets_claim_invite": "Se ha enviado una invitación para reclamar un billete",
    "place_order_without_tickets": "Pedido sin envío de tickets",
    "guest_list_payment_terms": "Qué le gustaría hacer con el pago?",
    "guest_list_what_next": "¿Qué le gustaría hacer a continuación?",
    "guest_list_order_confirmation_with_tickets_and_payment": "Envío de la confirmación del pedido de los clientes añadidos",
    "guest_list_order_confirmation_with_tickets": "Envío de la confirmación del pedido de los clientes añadidos",
    "guest_list_order_confirmation": "Envío de la confirmación del pedido de los clientes añadidos",
    "multi_tickets_created": "Se han enviado los billetes",
    "guest_list_order_confirmation_with_payment": "Envío de la confirmación del pedido de los clientes añadidos",
    "guest_list_send_all_tickets_to_order_owner": "Los billetes han sido enviados al titular del pedido",
    "guest_list_send_tickets_to_ticket_holders": "El billete se ha enviado directamente a un titular",
    "guest_list_todo_next_send_payment_link": "Enviar un enlace de pago",
  "guest_list_todo_next_send_payment_link_description": "El propietario del pedido recibirá un correo electrónico con un enlace de pago",
    "ticket_created": "El billete ha sido enviado",
	"event_name_64_char": "El nombre del evento no puede tener menos de 4 caracteres ni más de 64.",
	"report_orders_grouped_by_tickets": "Pedidos agrupados por número de entradas",
  "report_tickets_per_order": "Entradas por pedido",
  "report_number_of_orders": "Número de pedidos",
  "report_order_placed": "Pedido realizado",
  "report_ticket_type": "Tipo de billete",
  "report_tickets_selected": "Billete(s) seleccionado(s)",
  "report_select_ticket": "Seleccione el billete",
  "ticket_is_required": "El campo Entradas es obligatorio",
  "reset_password": "Restablecer la contraseña",
  "password_reset_successfully": "La contraseña se ha restablecido con éxito",
  "password_confirmation": "Confirmación de la contraseña",
  "company_user_reset_password_checkbox": "Permitir al usuario restablecer la contraseña al iniciar la sesión",
  "password_not_match": "Las contraseñas no coinciden",
  "password_reset_user_should_reset_password": "Necesitas restablecer la contraseña",
  "ticket_secret": "El secreto del billete",
  "scanner_terminal_showing_of_entries": "Mostrando {per_page} de {total} entradas",
  "Buscar en": "Search",
  "scanner_terminal_filter_btn": "Filtro",
  "ticket_unclaimed_reminding": "Recordatorio de reclamación de entradas",
  "order_refund_choose_which_products_to_refund": "Elija qué producto(s) desea reembolsar",
  "order_refund_include_ticket_fees": "Incluir los gastos de administración de {total} en el reembolso",
  "order_refund_include_payment_fees": "Incluir los gastos de administración de pagos de {total} en la devolución",
  "order_refund_total_amount": "Importe total a reembolsar:",
  "order_refund_total_bigger_paid": "El importe total que se devuelve nunca puede ser mayor que el importe total pagado",
  "could_not_process_payment": "No se ha podido procesar el pago",
  "company_refund_fee": "Tasa por reembolso",
  "nav_master_data": "Datos maestros",
  "roles_roles_permissions": "Permisos de rol",
  "roles_permission_roles": "Roles de permiso",
  "roles_name": "Nombre",
  "roles_admin_only": "Sólo para administradores",
  "roles_online": "En línea",
  "roles_created_by": "Creado por",
  "role_saved_successfully": "Rol guardado con éxito",
  "role_deleted_successfully": "Rol borrado con éxito",
  "company_permissions": "Permisos de la empresa",
  "company_user_settings_tab": "Configuración del usuario",
  "company_permissions_tab": "Permisos",
  "not_have_permission": "No tiene permiso para acceder a esta página",
  "scanner_terminal_btn_check_in": "Regístrese",
  "permission_order_overview_view": "Vista de resumen de pedidos",
  "permission_stock_report_view": "Vista del informe de existencias",
  "permission_admin_company_overview_view": "Vista de la administración de la empresa",
  "permission_admin_company_payment_costs_view": "Vista de los costes de pago de la empresa administrativa",
  "permission_admin_company_payment_costs_edit": "Administrar los costes de pago de la empresa editar",
  "permission_admin_company_payment_costs_create": "Los costes de pago de la empresa administradora crean",
  "permission_admin_company_user_impersonate": "Suplantar al usuario de la empresa administradora",
  "permission_admin_company_details_view": "Vista de los detalles de la empresa administrativa",
  "permission_admin_company_details_edit": "Admin detalles de la empresa editar",
  "permission_order_overview_export": "Exportar resumen de pedidos",
  "permission_order_overview_search": "Buscar en el resumen del pedido",
  "permission_order_detail_view": "Vista de detalles del pedido",
  "permission_order_cancel": "Cancelar el pedido",
  "permission_order_refund": "Reembolso del pedido",
  "permission_order_order_confirmation": "Confirmación del pedido",
  "permission_order_detail_product_cancel": "Pedido detalle producto cancelar",
  "permission_order_detail_product_change_owner": "Detalle del pedido cambio de propietario del producto",
  "permission_order_detail_change_customer_details": "Detalle del pedido cambio de datos del cliente",
  "permission_add_attendees_view": "Vista de añadir asistentes",
  "permission_event_overview_view": "Vista general del evento",
  "permission_event_create": "Crear evento",
  "permission_event_delete": "Eliminar evento",
  "permission_event_duplicate": "Duplicar evento",
  "permission_event_details_view": "Vista de los detalles del evento",
  "permission_event_details_edit": "Editar detalles del evento",
  "permission_event_products_view": "Vista de los productos del evento",
  "permission_event_products_edit": "Editar productos del evento",
  "permission_event_products_delete": "Eliminar productos del evento",
  "permission_event_products_create": "Crear productos del evento",
  "permission_event_timeslot_view": "Vista de la franja horaria del evento",
  "permission_event_customer_information_view": "Vista de la información del cliente del evento",
  "permission_event_customer_information_edit": "Editar la información del cliente del evento",
  "permission_event_point_of_sale_view": "Vista del punto de venta del evento",
  "permission_event_point_of_sale_create": "Evento punto de venta crear",
  "permission_event_point_of_sale_edit": "Edición del punto de venta del evento",
  "permission_reports_view": "Vista de informes",
  "permission_reports_sales_by_tickettype_view": "Vista de informes de ventas por tipo de billete",
  "permission_discountcode_view": "Vista del código de descuento",
  "permission_discountcode_create": "Crear código de descuento",
  "permission_discountcode_edit": "Editar código de descuento",
  "permission_scan_operation_view": "Vista de la operación de escaneo",
  "permission_scan_operation_create": "Crear operación de escaneo",
  "permission_scan_operation_edit": "Editar operación de escaneo",
  "permission_ticket_template_view": "Vista de la plantilla de tickets",
  "permission_ticket_template_create": "Crear plantilla de ticket",
  "permission_ticket_template_edit": "Editar plantilla de tickets",
  "permission_my_company_view": "Vista de mi empresa",
  "permission_my_company_user_create": "Crear usuario de mi empresa",
  "permission_my_company_user_edit": "Usuario de mi empresa editar",
  "permission_my_company_user_delete": "El usuario de mi empresa se borra",
  "permission_my_company_layout_view": "Vista del diseño de mi empresa",
  "permission_my_company_layout_edit": "Editar el diseño de mi empresa",
  "permission_dashboard_view": "Vista del panel de control",
  "permission_customer_support_view": "Vista de soporte al cliente",
  "permission_admin_company_permission_view": "Vista de los permisos de administración de la empresa",
  "permission_admin_company_permission_edit": "Editar los permisos de la empresa del administrador",
  "permission_my_company_user_permissions_view": "Vista de los permisos de los usuarios de mi empresa",
  "permission_my_company_user_permissions_edit": "Editar los permisos de los usuarios de mi empresa",
  "permission_master_data_view": "Vista de datos maestros",
  "permission_master_data_permissions_roles_view": "Vista de los roles de los permisos de los datos maestros",
  "permission_master_data_permissions_roles_edit": "Editar los permisos de los datos mae§stros",
  "permission_admin_automatic_invoicing_view": "Vista de la facturación automática del administrador",
  "permission_no_company_privileges": "No se han establecido privilegios de empresa",
  "user_allowed_events": "Seleccionar los eventos específicos que el usuario puede ver",
  "permission_role_templates": "Role templates",
  "permission_events_selected": "Evento(s) seleccionado(s)",
  "permission_all_events": "Todos los eventos",
  "search": "Buscar",
  "permission_master_data_permission_roles_create": "Roles de permisos de datos maestros crear",
  "permission_master_data_permissions_roles_delete": "Roles de permisos de datos maestros eliminar",
  "permission_admin_company_add_company": "Admin empresa puede añadir empresa",
  "permission_admin_company_automatic_invoicing_edit": "Admin edición automática de la facturación",
  "permission_admin_company_users_view": "Administrar la vista de los usuarios de la empresa",
  "permission_admin_company_users_edit": "Administrar los usuarios de la empresa",
  "permission_admin_company_users_delete": "Administrar usuarios de la empresa borrar",
  "permission_order_detail_payment_history_view": "Vista del historial de pagos del pedido",
  "permission_order_detail_notes_view": "Vista de las notas del detalle del pedido",
  "permission_order_detail_notes_create": "Creación de notas de detalle del pedido",
  "permission_order_detail_log_view": "Vista del registro del detalle del pedido",
  "permission_my_company_users_view": "Vista de los usuarios de mi empresa",
  "permission_event_visitor_list_view": "Vista de la lista de visitantes del evento",
  "event_created": "Se ha creado el evento",
  "scan_operation_created": "Se ha creado la operación de escaneo",
  "ticket_template_created": "Se ha creado la plantilla del billete",
  "permission_my_company_settings_edit": "Edición de la configuración de mi empresa",
  "permission_my_company_settings_view": "Vista de la configuración de mi empresa",
  "permission_scan_terminal_view": "Vista del terminal de exploración",
  "permission_admin_company_details_page_view": "Vista de la página de detalles de la empresa del administrador",
  "event_duplicated": "El evento ha sido duplicado",
  "admin_company_payment_costs_create": "Añadir un nuevo método de pago",
  "admin_company_add_payment_method": "Añadir un nuevo método de pago",
  "admin_company_payment_method": "Método de pago",
  "admin_company_payment_method_fee_percentage": "Tasa en porcentaje",
  "admin_company_payment_method_fee_fixed": "Tarifa fija",
  "admin_company_payment_method_start_at": "Válido desde",
  "error_fee_fixed_amount": "La cuota fija es obligatoria",
  "error_fee_percentage": "El porcentaje de la tasa es obligatorio",
  "admin_company_payment_method_added": "Método de pago añadido",
  "my_company_layout_remove_image": "Quitar la imagen",
  "my_company_invoice_language": "¿En qué idioma debe redactarse la factura?",
  "permission_discountcode_delete": "Código de descuento eliminado",
  "discountcode_deleted": "Código de descuento borrado",
  "discountcode_is_used": "El código de descuento ya ha sido utilizado y por lo tanto no puede ser eliminado",
  "order_details_change_order_event": "Cambiar la orden a un evento diferente",
  "order_details_event_changed_message": "El evento de la orden se cambia con éxito.",
  "permission_order_detail_change_event": "Evento de cambio de detalles del pedido",
  "pos_payment_method_not_exists": "El método de pago en el punto de venta no existe",
  "order_details_change_event_modal_products_title": "Elija los nuevos productos",
  "order_details_change_event_modal_event": "Elija el evento al que desea cambiar el orden",
  "order_details_change_event_modal_pos": "Elija el punto de venta al que desea cambiar el pedido",
  "permission_admin_company_fee_view": "Vista de la cuota de la empresa administradora",
  "permission_admin_company_fee_edit": "Editar la cuota de la empresa administradora",
  "permission_admin_company_fee_add": "Añadir la cuota de la empresa administradora",
  "admin_company_add_company_fee": "Añadir tasa de la empresa",
  "admin_company_fee_type": "Tipo de tasa",
  "admin_company_fee": "Tasa",
  "admin_company_fee_start_at": "Comienza en",
  "admin_company_company_fee_updated": "Tasa de la empresa actualizada",
  "admin_company_company_fee_added": "Tasa de la empresa añadida",
  "admin_company_company_fee_ticket_fee": "Tarifa de la entrada",
  "admin_company_company_fee_box_office_ticket_fee": "Tasa de taquilla",
  "admin_company_company_fee_refund_fee": "Tasa de reembolso",
  "admin_company_company_fee_free_tickets_free_percentage": "Porcentaje de gratuidad de las entradas",
  "admin_company_company_fee_free_ticketfee": "Tasa de entradas gratuitas",
  "update": "Actualización",
  "administration_overview_invoice": "Resumen de la factura",
  "backend_title_invoices_overview": "Resumen de la factura",
  "permission_admin_administration_view": "Ver administración",
  "permission_invoice_details_view": "Ver detalles de la factura",
  "permission_invoice_overview_search": "Búsqueda de resumen de facturas",
  "permission_invoice_overview_view": "Ver resumen de facturas",
  "permission_order_detail_generate_ticket": "El detalle del pedido genera un nuevo ticket",
  "permission_invoice_details_create_credit_invoice": "Detalles de la factura crear factura de crédito",
  "invoice_details_create_credit_invoice": "Crear factura de crédito",
  "permission_mgmt_app_login": "Puede iniciar sesión",
  "permission_mgmt_app_event_submenu_checkin_view": "Resumen de la facturación",
  "permission_mgmt_app_event_scan_total_tickets_scanned_view": "Ver el total de billetes escaneados en la pantalla del escáner",
  "permission_mgmt_app_event_checkin_swipe_checkout": "Desplazamiento de la facturación",
  "permission_mgmt_app_event_dashboard_tickets_sold_view": "Resumen de las entradas vendidas en el tablero",
  "permission_mgmt_app_ticket_detail_view": "Puede ver los detalles del billete",
  "permission_mgmt_app_event_scan_ticket_details_view": "Mostrar los detalles del billete después de escanearlo",
  "permission_mgmt_app_prices_view": "Mostrar precios",
  "permission_mgmt_app_event_overview_active_events": "Ver los eventos activos",
  "permission_mgmt_app_event_overview_past_events": "Ver eventos pasados",
  "permission_mgmt_app_menu_search_in_all_orders_view": "Buscar en todos los pedidos",
  "permission_mgmt_app_menu_device_settings_view": "Menú de configuración del dispositivo",
  "permission_mgmt_app_menu_event_overview_view": "Resumen del evento del menú",
  "permission_mgmt_app_event_submenu_dashboard_view": "Resumen del panel de control",
  "permission_mgmt_app_event_dashboard_tickets_scanned_view": "Visión general de los billetes escaneados en el tablero de mandos",
  "permission_mgmt_app_event_submenu_orders_view": "Resumen del pedido",
  "permission_mgmt_app_event_submenu_home_view": "Resumen del evento",
  "permission_mgmt_app_event_checkin_swipe_checkin": "Registro de entrada con tarjeta de crédito",
  "permission_mgmt_app_event_checkin_scan_btn_view": "Botón de escaneo para mostrar el check-in",
  "permission_mgmt_app_ticket_detail_btn_checkout": "Detalle del billete desescaneado",
  "permission_mgmt_app_ticket_detail_btn_checkin": "Comprobación de los detalles del billete",
  "permission_mgmt_app_event_checkin_product_settings_view": "Resumen de los ajustes específicos del producto",
  "permission_mgmt_app_event_checkin_product_settings_update": "Puede configurar qué productos escanear",
  "permission_mgmt_app_ticket_sales_view": "Puede ver la venta de entradas",
  "administration_invoice_number": "Número de factura",
  "permission_administration_overrule_fees_per_event_view": "Tasa de anulación de la administración por vista del evento",
  "permission_administration_overrule_fees_per_event_edit": "Tasas de anulación de la administración por evento editar",
  "administration_event_fees": "Tasa de anulación por evento",
  "event_fees_retroactive": "Retroactivo",
  "edit": "Editar",
  "company": "Empresa",
  "permission_mgmt_app_user_device_settings_view": "Ver la configuración del dispositivo del usuario",
  "permission_mgmt_app_user_device_settings_update": "Actualizar la configuración del dispositivo del usuario",
  "pos_terms_conditions_url": "Términos y condiciones url",
  "cart_terms_conditions2": "Al hacer clic en el botón 'Continuar' confirma que ha leído y está de acuerdo con los <a href='{url}' target='_blank'>Términos y condiciones</a> & <a href='https://fairtix.io/es/privacy-policy' target='_blank'>Política de Privacidad</a> de Fairtix & <a href='{url2}' target='_blank'>Términos y condiciones</a> de {name}.",
  "pos_invalid_url": "URL inválida",
  "company_tickets_sold_out_notification": "Enviar notificación de casi agotado",
  "report_days_before_event": "{days} días antes del evento",
  "report_event_day": "Fecha de inicio del evento",
  "report_days_from_event": "{days} días desde el inicio del evento",
  "report_free_tickets": "de los cuales, entradas gratuitas",
  "company_layout_logo_url": "URL del logotipo",
  "pos_stock_pos": "POS",
  "pos_stock_product": "Producto",
  "pos_stock_product_stock": "Stock de productos",
  "pos_stock_in_redis": "En redis",
  "pos_stock_pos_stock": "Stock POS",
  "pos_stock_sold": "Vendido",
  "email_confirmation": "Confirmar email",
  "customer_form_email_confirmation_not_match": "Los correos electrónicos no coinciden",
  "report_in_worth_of": "En valor de",
  "order_already_paid": "¡Pedido ya pagado!",
  "customer_form_click_on_claim_button": "Haga clic en el botón Reclamar billete para enviar el billete a su dirección de correo electrónico",
  "pos_no_language": "Ningún idioma seleccionado",
  "customer_information_specific_tickets": "Haga esta pregunta sólo cuando el pedido contenga entradas específicas",
  "scan_terminal_choose_event_title": "Elija un evento para el que desee iniciar el Terminal de Escaneo",
  "permission_scan_terminal_login": "Inicio de sesión en el terminal de escaneado",
  "permission_scan_terminal_ticket_overview": "Visión general de las entradas del terminal de escaneado",
  "no_events_to_show": "No hay eventos que mostrar",
  "reports_scans_by_type": "Exploraciones por tipo",
  "reports_tickets_scans": "Billetes escaneados",
  "reports_tickets_scans_hourly": "Cada hora",
  "reports_tickets_scans_daily": "Diario",
  "reports_tickets_scans_weekly": "Semanal",
  "reports_tickets_scans_monthly": "Mensual",
  "reports_period": "Periodo",
  "reports_time_from": "Tiempo desde",
  "reports_time_to": "Hora hasta",
  "reports_tickets_scanned": "Billetes escaneados",
  "customer_information_field": "Campo",
  "customer_information_order_ask": "Pedido",
  "customer_information_order_mandatory": "Hacer obligatorio",
  "customer_information_ticket_ask": "Pedir billete",
  "customer_information_ticket_mandatory": "Hacer obligatorio",
  "customer_information_specific_question": "Pregunta",
  "customer_information_specific_question_type": "Tipo de pregunta",
  "report_sold_out": "Agotado",
  "back": "Volver",
  "my_company_allowed_events_days": "El usuario tendrá acceso a todos los eventos que se celebren en los días que seleccione a continuación",
  "day_mon": "Mon",
  "day_tue": "Tue",
  "day_wed": "Wed",
  "day_thu": "Thu",
  "day_fri": "Fri",
  "day_sat": "Sat",
  "day_sun": "Sun",
  "company_paynl_account_type": "Pay.nl tipo de cuenta",
  "company_payout_iban": "Número IBAN de pago",
  "company_name_is_required": "Nombre obligatorio",
  "company_domain_is_required": "Subdominio obligatorio",
  "company_contact_is_required": "Persona de contacto obligatoria",
  "pos_url_exists": "Se utilizan algunas o todas las urls POS",
  "permission_event_show_minimum_age_checkbox": "Evento mostrar casilla de edad mínima",
  "event_age_confirmation_form": "Permite que el cliente marque una casilla para confirmar que tiene al menos {age} años",
  "pos_age_confirmation": "Confirmo que yo y las demás personas para las que pido entradas tenemos al menos {minimum_age} o más.",
  "ticket_template_duplicate" : "Plantilla duplicada",
  "ticket_template_delete_entry" : "¿Está seguro de que desea eliminar esta plantilla de ticket?",
  "name_is_required" : "El nombre es obligatorio",
  "permission_ticket_template_duplicate": "Duplicado de plantilla de ticket",
  "default_account_setup": "Configuración de cuenta predeterminada",
  "backend_title_default_company_layout": "Diseño de empresa predeterminado",
  "backend_title_default_company_fees": "Tarifas predeterminadas",
  "backend_title_default_company_permissions": "Permisos predeterminados",
  "backend_title_default_ticket_template": "Plantilla de ticket por defecto",
  "default_company_layout": "Diseño de empresa predeterminado",
  "default_company_fees": "Tarifas predeterminadas",
  "default_company_permissions": "Permisos predeterminados",
  "default_company_ticket_template": "Plantilla de ticket por defecto",
  "permission_master_data_default_values_permissions_edit": "Edición de permisos predeterminados",
  "permission_master_data_default_values_permissions_view": "Vista de permisos predeterminados",
  "permission_master_data_default_values_view": "Vista de valores predeterminados",
  "permission_master_data_default_values_layout_edit": "Edición de diseño de empresa predeterminado",
  "permission_master_data_default_values_layout_view": "Vista de diseño de empresa predeterminada",
  "permission_master_data_default_values_fees_edit": "Editar tarifas predeterminadas de la empresa",
  "permission_master_data_default_values_fees_view": "Vista de tarifas de empresa predeterminadas",
  "permission_master_data_default_values_ticket_template_view": "Vista por defecto de la plantilla de ticket",
  "permission_master_data_default_values_ticket_template_edit": "Editar plantilla de ticket por defecto",
  "field_is_required": "Se requiere campo",
  "password_mismatch": "Contraseña no coincide",
  "user_already_exists": "El usuario ya existe",
  "signup_create_account": "Crear una cuenta",
  "signup_enter_details": "La creación de la cuenta es totalmente gratuita.",
  "signup_chamber_of_commerce": "Cámara de Comercio",
  "signup_iban": "IBAN",
  "signup_iban_holder_name": "Nombre del titular de la cuenta IBAN",
  "signup_confirm_password": "Confirmar Contraseña",
  "signup_terms": "Acepto los <a target='_blank' href='https://fairtix.io/es/terms-conditions'>Términos y condiciones</a> y declaro que estoy autorizado a firmar en nombre de la organización especificada.",
  "signup_already_user": "¿Ya tienes una cuenta?",
  "signup_loading_creating_account": "Creando cuenta...",
  "signup_loading_configuring_the_layout": "Configurando el diseño...",
  "signup_loading_almost_done": "Casi termino...",
  "signup_loading_go_to_dashboard": "Ir al panel de control como usuario registrado",
  "default_template_text": "Plantilla por defecto",
  "signup_step_2_title": "Completar la cuenta",
  "signup_step_2_enter_details": "Facilite los últimos datos",
  "edit_ticket_template_err_no_jpg": "La imagen elegida debe tener formato JPG",
  "edit_ticket_template_err_no_textbox": "Se requiere un mínimo de un cuadro de texto",
  "error_background": "La imagen es obligatoria",
  "event_description_location": "Dónde desea mostrar la descripción",
  "manage_event_desc_location_top": "Al principio de la página",
  "manage_event_desc_location_bot": "Al final de la página",
  "event_show_image_in_pos": "Mostrar imagen en la página de ventas",
  "product_scan_color": "Anular el color de escaneado",
  "product_scan_color_explenation": "Si se establece un color aquí, se mostrará en cuanto se escanee correctamente este billete.",
  "product_remove_scan_color": "Eliminar color de escaneado",
  "pos_no_products_and_pm_are_configured": "No hay productos ni métodos de pago configurados",
  "pos_no_products_are_configured": "No hay productos configurados",
  "pos_no_pm_are_configured": "No hay métodos de pago configurados",
  "event_marketing_updated": "Marketing de eventos actualizado",
  "permission_event_marketing_view": "Marketing de eventos",
  "permission_event_marketing_edit": "Edición de marketing para eventos",
  "event_marketing_gtm_id": "ID de Google Tag Manager",
  "event_marketing_gtm_id_tooltip": "Una vez rellenado el ID de GTM, GTM se activará en la página de ventas. Vacíe este campo para desactivarlo de nuevo.",
  "edit_ticket_template_err_textbox_field": "Todos los campos del cuadro de texto son obligatorios",
  "discountcode_times_used": "Veces utilizado",
  "nav_campaigns": "Campañas",
  "campaign_create": "Crear campaña",
  "campaign_modal_create": "Crear una nueva campaña",
  "campaign_name": "Nombre de la campaña",
  "campaign": "Campaña",
  "slug": "Slug",
  "event_day_selector": "Selector de evento/día",
  "campaign_discount_rules": "Reglas de descuento",
  "campaign_discount_type": "Tipo de descuento",
  "campaign_discount_value": "Valor de descuento",
  "campaign_new_discount_rule": "Nueva regla de descuento",
  "campaign_reference": "Referencia",
  "campaign_when_does_this_discount_apply": "Cuándo se aplica este descuento",
  "campaign_timeframe_from": "Plazo desde",
  "campaign_timeframe_to": "Plazo hasta",
  "reference_is_required": "Se requiere referencia",
  "campaign_edit_rule": "Editar regla",
  "campaign_rule_set_product_price": "Precio del producto",
  "campaign_rule_set_product_name": "Nombre del producto",
  "campaign_updated": "Campaña actualizada correctamente",
  "slug_is_required": "Slug requerido",
  "campaign_company_url": "URL de la campaña de la empresa",
  "campaign_deleted": "Campaña eliminada correctamente",
  "cannot_delete_campaign": "No se puede borrar la campaña, tiene pedidos asociados",
  "campaign_times_used": "Tiempos utilizados",
  "campaign_total_revenue": "Ingresos totales",
  "slug_already_used": "Babosa ya en uso",
  "copied_to_clipboard": "Copiado al portapapeles.",
  "order_overview_remove_discountcode_filter": "Quitar el filtro discountcode",
  "discountcode_overview_show_orders": "Mostrar pedidos",
  "discountcode_tickets_times_used": "Número de entradas",
  "report_age_avg": "Edad media",
  "pos_countdown": "Mostrar cuenta atrás",
  "pos_countdown_datetime": "Hasta cuándo la cuenta atrás del reloj",
  "dashboard_modal_active_carts": "Carros activos",
  "layout_countdown": "Reloj de cuenta atrás",
  "layout_countdown_card_top": "Reloj superior de la tarjeta",
  "layout_countdown_card_bottom": "Parte inferior del reloj",
  "layout_countdown_card_text": "Color del texto dígitos",
  "permission_campaigns_view": "Vista de las campañas",
  "permission_campaigns_create": "Las campañas añaden",
  "permission_campaigns_edit": "Campañas editar",
  "permission_campaigns_delete": "Eliminar campañas",
  "discountcode_allowed_events": "Eventos permitidos",
  "discountcode_allowed_products": "Productos permitidos",
  "order_discountcode": "Código descuento",
  "nav_batches": "Lotes de códigos QR",
  "batch_name": "Batch Name",
  "ticket_name": "Nombre del billete",
  "ticket_price": "Precio del billete",
  "ticket_vat": "Vat del Billete",
  "tickets_count": "¿Cuántos códigos QR quieres hacer?",
  "starts_at": "A partir de",
  "ends_at": "Termina en",
  "batch_events_or_days": "Elija los eventos o días en los que el lote es válido",
  "edit_batch_title": "Editar lote",
  "create_batch": "Crear lote",
  "batch_created": "Lote creado",
  "batch_updated": "Lote actualizado",
  "batch_modal_create": "Crear nuevo lote",
  "ticket_name_is_required": "El nombre de la entrada es obligatorio",
  "ticket_price_is_required": "El precio del billete es obligatorio",
  "ticket_vat_is_required": "Billete IVA requerido",
  "tickets_count_err": "El número de códigos QR debe ser superior a 0 e inferior a 5000",
  "batch_generate": "Generar lote QR",
  "batch_download": "Descargar lote QR",
  "batch_generated": "Los códigos QR se están creando, esto puede llevar un tiempo",
  "batch_already_generated": "Ya se ha generado el lote",
  "order_overview_batch_ticket": "Billete de lote",
  "download": "Descargar",
  "qr_code": "Código QR",
  "pos_qr_description": "Este código QR está vinculado al punto de venta. Se puede utilizar en su folleto o para otros fines de marketing.",
  "campaign_highlight_discount": "Destacar los productos con descuentos",
  "campaign_highlight_discount_border_color": "Color del borde",
  "campaign_highlight_discount_background_color": "Color de fondo",
  "campaign_hide_products": "Quiero ocultar algunos productos específicos en la página de ventas",
  "campaign_when_hide_products": "Ocultar los productos cuando:",
  "different": "Diferentes",
  "event_vat_is_required": "Se exige el IVA",
  "password_validation_8_chars": "La contraseña debe tener al menos 8 caracteres",
  "password_validation_lowercase": "La contraseña debe tener al menos una letra minúscula",
  "password_validation_capital": "La contraseña debe tener al menos una letra mayúscula",
  "password_validation_number": "La contraseña debe tener al menos un número",
  "signup_confirm_account": "Confirme sus datos",
  "signup_password_strength": "La contraseña debe tener 8 caracteres y contener al menos 1 número, 1 letra, 1 mayúscula y 1 carácter especial.",
  "discountcode_apply_type": "¿Cómo desea calcular el descuento?",
  "discountcode_apply_type_order": "Por pedido",
  "discountcode_apply_type_ticket": "Por billete",
  "campaign_qr_description": "Este código QR está vinculado a la campaña. Puede utilizarse para un folleto o el código QR puede difundirse de cualquier otra forma.",
  "password_validation_special_char": "La contraseña debe tener al menos un carácter especial",
  "export_order_timeslot": "Horario",
  "export_customer_dob": "Fecha de nacimiento del cliente",
  "product_show_when_product_chosen": "Mostrar este producto sólo si se ha seleccionado otro",
  "event_products_selected": "producto(s) seleccionado(s)",
  "event_products_no_selected": "ningún producto seleccionado",
  "product_show_hide_input_fields": "Mostrar/Ocultar campos de entrada",
  "product_min_max_buy_per_product": "Compra mínima y máxima por pedido",
  "product_more_items": "Más artículos",
  "product_image_validate_size": "El tamaño de la imagen debe ser inferior a 4 MB",
  "product_image_validate_resolution": "La resolución de la imagen debe ser inferior a 120x120 px",
  "product_sell_product_sets": "Vender el producto en lotes de",
  "master_data_auto_invoice_settings": "Configuración de facturas automáticas",
  "nav_auto_invoice_settings": "Configuración de facturas automáticas",
  "auto_invoice_settings_general_stop": "¿Está activa la facturación automática?",
  "changes_saved": "Cambios guardados!",
  "error_max_buy": "El máximo por pedido es obligatorio",
  "error_min_buy": "Mínimo obligatorio por pedido",
  "product_price_inclusive_vat": "Precio (IVA incl.)",
  "product_image_tooltip": "La imagen debe tener un tamaño inferior a 4 MB, una resolución máxima de 120 x 120 píxeles y estar en formato PNG o JPEG",
  "product_send_additional_ticket": "Enviar un ticket adicional",
  "product_send_additional_ticket_ordered": "Enviar un ticket adicional cuando se pida este producto",
  "product_addition_already_set": "Este ticket ya está configurado como ticket adicional para {product}",
  "product_additional_ticket_description": "Al realizar el pedido de este producto, los productos que seleccione a continuación se añadirán automáticamente a la cesta al realizar el pedido",
  "event_product_send_email": "Enviar correo electrónico cuando se pida este producto a",
  "email_is_invalid": "Por favor, añada una dirección de correo electrónico válida",
  "permission_product_ordered_email_confirmation": "Confirmación por correo electrónico del producto solicitado",
  "guest_list_order_ticket_send_successfully": "Las entradas se han enviado correctamente",
  "guest_list_order_ticket_generated": "Los tickets están siendo generados y enviados, por favor espere hasta que este proceso haya finalizado...",
  "pos_free_order_btn": "Continuar con el pedido",
  "company_invoice_overview": "Factura",
  "company_invoice_overview_invoice": "Factura",
  "company_invoice_overview_payout_summary": "Apuntalamiento del desembolso",
  "invoice_number": "Nombre de la factura",
  "all_events": "Todos los eventos",
  "company_invoice_downloads": "Descargas",
  "company_paynl_merchant_id": "Pay.nl M-code",
  "company_invoice_overview_total_payout": "Desembolso total",
  "company_invoice_overview_clearing_ref": "Referencia de compensación",
  "company_invoice_overview_time_period": "Periodo de tiempo",
  "permission_company_invoice_view": "Vista general de facturas",
  "permission_company_invoice_can_download": "Puede descargar facturas",
  "point_of_sale_modal_delete": "Eliminar el punto de venta",
  "point_of_sale_delete_confirmation": "¿Está seguro de que desea eliminar este enchufe?",
  "point_of_sale_has_orders": "El punto de venta tiene pedidos, no se puede eliminar",
  "point_of_sale_has_been_deleted": "Se ha suprimido el punto de venta",
  "permission_event_point_of_sale_delete": "Eliminar el punto de venta",
  "campaign_overview_btn_link_generator": "Generador de enlaces",
  "campaign_link_modal_title": "Generador de enlaces",
  "campaign_campagne": "Campaña",
  "campaign_link_modal_link_type": "Tipo de enlace",
  "campaign_link_modal_event_overview": "Resumen del evento",
  "campaign_link_modal_specific_pos": "Punto de venta específico",
  "campaign_event": "Evento",
  "campaign_pos": "Punto de venta",
  "campaign_link_modal_link": "Enlace",
  "cart_incl_vat": "Con IVA",
  "fairtix_location_street": "Spoorstraat 153",
  "fairtix_location_zip": "6591GT",
  "fairtix_location_city": "Gennep",
  "fairtix_location_country": "The Nederlands",
  "fairtix_location_coc": "77888286",
  "fairtix_location_vat": "NL861186163B01",
  "shop_vat": "IVA",
  "extension_mailchimp": "Mailchimp",
  "extension_mailchimp_api_key": "API clave",
  "extension_mailchimp_audience_id": "Audience clave",
  "saved_successfully": "Guardado con éxito",
  "extension_mailchimp_description": "Configure la sincronización con Mailchimp. La dirección de correo electrónico, el nombre y los apellidos (si están disponibles) se enviarán a Mailchimp por lotes cada 60 minutos. Si desea detener la sincronización, elimine la clave API.",
  "momday": "Lunes",
  "tuesday": "Martes",
  "wednesday": "Miércoles",
  "thursday": "Jueves",
  "friday": "Viernes",
  "saturday": "Sábado",
  "sunday": "Domingo",
  "januuary": "Enero",
  "february": "Febrero",
  "march": "Marzo",
  "april": "Abril",
  "may": "Mayo",
  "june": "Junio",
  "july": "Julio",
  "august": "Agosto",
  "september": "Septiembre",
  "october": "Octubre",
  "november": "Noviembre",
  "december": "Diciembre",
  "company_show_calendar": "Mostrar el calendario en la página de eventos",
  "company_calendar_sold_ratio": "Mostrar indicación de ocupación en el calendario",
  "permission_extensions_overview_view": "Vista general de extensiones",
  "permission_extension_mailchimp": "Mailchimp",
  "permission_batch_overview_view": "Vista general de lotes",
  "permission_batch_edit": "Editar lotes",
  "permission_batch_create": "Crear lotes",
  "permission_master_data_auto_invoice_settings_view": "Auto invoice settings view",
  "permission_master_data_auto_invoice_settings_edit": "Auto invoice settings edit",
  "cookie_banner_title": "Cookies",
  "cookie_banner_personalize": "Personalice sus preferencias",
  "cookie_banner_preference_local": "Información guardada localmente",
  "cookie_banner_preference_analytics": "Analítica",
  "cookie_banner_preference_marketing": "Marketing",
  "btn_accept_all": "Aceptar todo",
  "btn_accept_selected": "Aceptar seleccionado",
  "cookie_banner_change_preference": "Cambiar las preferencias de cookies",
  "cookie_banner_text": "Nuestro sitio web utiliza cookies para ofrecerle la mejor experiencia de usuario posible. Esto nos permite, por ejemplo, recordar lo que ha añadido a su cesta de la compra. Además, aplicamos otros métodos útiles para mejorar su experiencia.",
  "order_overview_payment_link": "Enlace de pago",
  "guest_list_payment_link": "Enlace de pago",
  "guest_list_payment_link_send": "Enlace de pago enviado",
  "venues_overview": "Lugares de celebración",
  "venue_verified": "Se verifica",
  "venue_name": "Nombre del lugar",
  "new_venue": "Nueva sede",
  "venue_new_modal_title": "Crear una nueva sede",
  "venue_modal_edit": "Editar sede",
  "venue_address": "Dirección del lugar",
  "venue_zip": "Código postal del lugar",
  "venue_active": "Activo",
  "venue_city": "Lugar Ciudad",
  "venue_country": "Lugar País",
  "venue_saved": "Lugar guardado!",
  "venue_deleted": "Lugar suprimido!",
  "permission_master_data_venues_overview": "Lugares de celebración",
  "permission_venue_create": "Crear lugar",
  "permission_venue_delete": "Suprimir lugar",
  "permission_venue_edit": "Editar sede",
  "permission_add_location_event_details": "Añadir lugar en los detalles del evento",
  "event_location": "Ubicación",
  "venue_is_already_used": "El lugar ya está utilizado",
  "error_venue.name": "El nombre del lugar es obligatorio",
  "error_venue.address": "Se requiere la dirección del lugar de celebración",
  "error_address": "Se requiere la dirección del lugar de celebración",
  "error_venue.zip": "Se requiere el código postal del lugar de celebración",
  "error_zip": "Se requiere el código postal del lugar de celebración",
  "error_venue.city": "Se requiere la ciudad sede",
  "error_city": "Se requiere la ciudad sede",
  "error_venue.country_code": "Se requiere el país de la sede",
  "error_country_code": "Se requiere el país de la sede",
  "edit_ticket_template_reached_limit": "El tamaño de la imagen debe ser inferior a 300KB",
  "company_links_overview": "Enlaces de empresas",
  "company_master_name": "Empresa Master",
  "company_sub_name": "Empresa Sub",
  "location_id": "Ubicación",
  "location_name": "Ubicación",
  "company_link_new_modal_title": "Crear un nuevo enlace de empresa",
  "company_link_modal_edit": "Editar enlace de empresa",
  "company_link_saved": "Enlace de empresa guardado!",
  "company_link_deleted": "Enlace de empresa eliminado",
  "company_link_duplicate_entry": "Duplicación de enlaces de empresa",
  "company_link_master_sub_not_equal": "El jefe de la empresa no debe ser el subordinado de la empresa",
  "error_company_master_id": "Se requiere un maestro de empresa",
  "error_company_sub_id": "Se requiere sub de la empresa",
  "permission_master_data_company_links_overview": "Enlaces de la empresa",
  "permission_master_data_company_links_create": "Enlace de empresa Crear",
  "permission_master_data_company_links_edit": "Enlace de empresa Editar",
  "permission_master_data_company_links_delete": "Enlace de empresa Eliminar",
  "company_link_unallowed_parent_child_entry": "La subempresa no puede ser una cuenta subordinada de esta empresa, puesto que ya existe un vínculo en el que la empresa es una cuenta principal",
  "end_date_must_be_greater": "La fecha final debe ser mayor que la fecha inicial",
  "product_limit_amount_to_maximum_tickets": "Limitar el importe al máximo de otros billetes",
  "birth_date_must_be_past": "La fecha de nacimiento debe ser anterior",
  "product_scan_till_date_time": "Fecha y",
  "url_cannot_spaces": "La URL no puede contener espacios",
  "event_banner_tooltip": "Esta imagen se mostrará en el resumen de pos en la versión de escritorio",
  "event_banner_image": "Banner (1180x174 píxeles) (<=1MB)",
  "manage_event_remove_banner": "Eliminar banner",
  "manage_event_banner_error_res": "La resolución de la imagen del banner debe ser (1180x174 píxeles)",
  "manage_event_banner_error_size": "El tamaño de la imagen del banner debe ser inferior a 1MB",
  "order_number_of_products": "Número de productos",
  "user_app_login_duration": "Tiempo máximo de inicio de sesión en la aplicación (en horas)",
  "edit_user_modal_app_login_duration_error": "La duración máxima de inicio de sesión en la aplicación debe ser mayor que 0",
  "download_tickets": "Descargar entradas",
  "order_status_ticket_merging": "Los boletos se están fusionando",
  "invoice_overview_btn_generate_invoice": "Generar factura",
  "invoice_overview_btn_generate_payout_summary": "Generar resumen de pagos",
  "administration_invoice_payout_summary_generation": "Puede generar facturas y resúmenes de pagos",
  "invoice_overview_file_generated": "Archivo generado",
  "ticket_template_qr_code_4cm": "El código QR debe estar situado a 4CM (152PX) de los bordes de la página",
  "ticket_template_qr_size": "El código QR no debe ser inferior a 100x100 ni superior a 225x225",
  "export_product_ticket_value": "Código único de entrada",
  "select": "Seleccionar...",
  "permission_administration_invoice_payout_summary_generation": "Generación de facturas y resúmenes de pagos",
  "ticket_lost_title": "¿Ha perdido sus entradas?",
  "ticket_lost_description": "Rellene los campos siguientes para obtener sus entradas",
  "ticket_lost_no_orders":  "No hemos encontrado su(s) pedido(s), póngase en contacto con support-AtSign-fairtix.io para obtener más información",
  "ticket_lost_search_tickets": "Buscar entradas",
  "ticket_lost_your_orders_description": "Todas las entradas han sido enviadas a su dirección de correo electrónico. Compruebe también su carpeta de correo no deseado.",
  "wrong_email": "Dirección de correo electrónico no válida",
  "wrong_date":  "Fecha no válida",
  "company_order_thank_you_show_events": "Mostrar eventos en la página de agradecimiento",
  "order_thank_you_btn_event_details": "PEDIR AHORA",
  "order_thank_you_upcoming_events": "¡No se pierda tampoco estos acontecimientos!",
  "dashboard_events_ticket_sold": "vendido",
  "dashboard_events_ticket_guest_list": "Entradas lista invitados",
  "dashboard_events_yesterday": "Ayer",
  "date_and_time": "Fecha y hora",
  "start_date": "Fecha de inicio",
  "end_date": "Fecha de finalización",
  "event_modal_create": "Crear evento",
  "lang_fr": "Francés",
  "lang_pt": "Portugués",
  "pos_will_automatically_redirect": "Le redirigiremos automáticamente en {seconds} segundos al resumen del evento activo",
  "pos_redirect_now": "Redirigir ahora",
  "guest_list_event_name": "What event would you like to send guest list tickets for?",
  "guest_list_customer": "Who do you want to send the tickets to?",
  "guest_list_select_products": "How much do you want to send from which ticket?",
  "guest_list_send_to_email": "Send tickets to {email}",
  "guest_list_send_payment_request": "Send payment request to {email}",
  "guest_list_send_invitation_to_sign": "Send an invitation to sign tickets by name",
  "guest_list_select_payment": "What do you want to do with the payment?",
  "guest_list_select_payment_free": "No payment needing",
  "guest_list_select_payment_paid": "Cash has been paid",
  "guest_list_send": "Send",
  "guest_list_choose_tickets_to_send": "Choose tickets to send",
  "guest_list_ticket_type": "Tipo de billete",
  "guest_list_price": "Precio",
  "guest_list_number": "Número",
  "pos_only_available_x": "Max. {amount} disponible",
  "ticket_template_deleted": "Plantilla de ticket eliminada correctamente",
  "ticket_template_cannot_deleted":"No se puede eliminar la plantilla de ticket",
  "permission_ticket_template_delete": "Plantilla de ticket borrada",
  "order_overview_api_order": "API",
  "guest_list_remember_event": "Recordar evento para la próxima entrada",
  "order_export_generate_export": "Generar exportación",
  "order_export_export": "Exportar",
  "order_export_type": "¿Qué tipo de exportación desea crear?",
  "order_export_visitor_list": "Lista de visitantes (para entradas específicas)",
  "order_export_general": "Exportación general",
  "order_export_which_event": "¿Para qué evento?",
  "order_export_event": "Elija el evento",
  "order_export_which_tickets": "¿Para qué entradas?",
  "order_export_select_tickets": "Seleccione las entradas",
  "order_export_selected_tickets": "{count} seleccionadas",
  "order_export_which_email": "¿A qué dirección de correo electrónico desea enviar la exportación?",
  "order_export_period": "¿Qué periodo de tiempo?",
  "order_export_which_fields": "¿Qué campos desea incluir en la exportación?",
  "order_export_success": "Solicitado con éxito",
  "order_export_success_message": "Su exportación se ha solicitado correctamente y se enviará a {email}. Esto puede tardar varios minutos dependiendo del tamaño del archivo.",
  "order_export_all_tickets": "Todas las entradas",
  "event_product_allow_for_multiple_events": "Permitir varios eventos",
  "select_events": "Seleccionar eventos",
  "event_duplicate_product_allowed_events_note": "ATENCIÓN: Debes vincular manualmente nuevos eventos a este producto después de duplicarlo",
  "order_export_select_specific_event": "Seleccione un evento específico",
  "event_product_available_amount": "Cantidad disponible",
  "event_product_create_hint": "Una vez creada la entrada, puede configurar más opciones si lo desea.",
  "event_product_type_entrance": "Entrada",
  "event_product_type_tokens": "Fichas",
  "event_product_type_parking": "Aparcamiento",
  "event_product_type_cross-sell": "Venta cruzada",
  "event_product_type_merchandise": "Mercancía",
  "event_product_type_donation": "Donación",
  "event_product_type_other": "Otros",
  "event_product_create_success": "Producto creado con éxito.",
  "pos_buy_your_tickets": "¡Compra tus entradas ahora!",
  "pos_timeslot_choose_the_time":"Elija la hora de su visita",
  "pos_personal_details": "Datos personales",
  "pos_personal_details_complete_purchase":"Completa tu compra",
  "pos_payment": "Pago",
  "pos_payment_description":"Elija una forma de pago",
  "pos_order_success_title": "Su pedido: #{order_number} ¡se ha realizado correctamente!",
  "event_product_persons":"Número de personas",
  "persons": "Personas",
  "pos_place_order_total":"Total (incl. IVA y €{total} de gastos de reserva)",
  "pos_place_order_got_a_code": "¿Tienes un código?",
  "read_more": "Leer más",
  "read_less": "Leer menos",
  "layout_accent_color": "Color de acento",
  "layout_description_color": "Color de la descripción",
  "layout_buttons_color": "Color del botón",
  "layout_button_text_color": "Color del texto del botón",
  "pos_important_information": "Información importante",
  "shop_no_products_selected": "No se han seleccionado productos",
  "pos_buy_extra_products": "Compra productos adicionales",
  "event_description_open_status": "Mostrar descripción directamente",
  "event_manage_event_description_show_tooltip": "Si esta opción está activada, la descripción del evento se mostrará directamente en la página del evento. Si no está activada, es necesario desmarcarla manualmente.",
  "event_products_create_first_ticket": "¡Crea tu primer ticket!",
  "event_products_create_ticket_hint": "¡Todo gran evento comienza con un ticket, el tuyo! Haz clic en ese botón y crea tu ticket.",
  "event_products_create_ticket_btn": "Crear ticket",
  "event_products_create_pos": "¡Crea tu punto de venta!",
  "event_products_create_pos_hint": "¡Para poder vender tickets, necesitas un punto de venta! Haz clic en ese botón y crea tu punto de venta.",
  "event_products_create_pos_btn": "Crear punto de venta",
  "event_selected_products": "producto(s)",
  "event_products_mass_update": "Actualización masiva de productos",
  "event_products_group_name": "Nombre del grupo",
  "event_products_capacity": "Capacidad",
  "event_product_mass_update_success": "Productos actualizados con éxito",
  "pos_fill_in_discount_code": "Introduce tu código de descuento",
  "discount_code": "Código de descuento",
  "something_went_wrong": "Etwas ist schiefgelaufen",
  "pos_use_discount_code": "Utilizar código de descuento", 
  "btn_apply": "Aplicar"
  
}